<template lang='pug'>
  el-card.box-card(shadow='hover', v-loading="savingChanges")
    .clearfix(slot='header')
      el-button(style='float: right; padding: 5px 5px; margin: 10px 10px;', type='text', v-show='addUser || addForeignUser'  @click="hideForm") Κλείσιμο
      h3(v-show='addUser && !modifyUser && !modifyRole', align='center') Εγγραφή Nέου Xρήστη
      h3(v-show='!addUser && modifyUser && !modifyRole', align='center') Τροποποίηση Προφίλ Χρήστη
      h3(v-show='!addUser && !modifyUser && !modifyRole && addForeignUser', align='center') Εγγραφή Αλλοδαπού Χρήστη
      h3(v-show='!addUser && !modifyUser && modifyRole', align='center')
        | Προσθήκη/Αφαίρεση Χρηστών από τον Ρόλο {{roleName}}
    div
      el-form.ruleForm(:inline='true', :inline-message="true", :model='userCredentials',
         :rules='validationRules', ref='userCredentials', label-width='124px' size='small')
        el-form-item(label='Αλλαγή Κωδικού', v-if='modifyFromUser')
          el-switch.register(v-model='changePassword',
            active-text='Αλλαγή', inactive-text='Διατήρηση' active-value=true inactive-value=false)
        el-card(v-if='modifyFromUser && changePassword')
          .clearfix(slot='header')
            h3 Αλλαγή Κωδικού
          el-form-item(label='Παλιός κωδικός', prop='oldPassword')
            el-input.register(type='password', v-model='userCredentials.oldPassword',
              auto-complete='off', @change='modifyUserPassword') ########
          el-form-item(label='Νεος κωδικός', prop='password')
            el-input.register(type='password', v-model='userCredentials.password',
              auto-complete='off', @change='modifyUserPassword') ########
          el-form-item(label='Επανάληψη νεου κωδικού', prop='passwordConfirmation')
            el-input.register(type='password', v-model='userCredentials.passwordConfirmation',
              auto-complete='off', @change='modifyUserPassword') ########
        hr
        el-form-item(label='Email', prop='email', size='large', v-show='!modifyRole')
          el-input.register(type='name', v-model='userCredentials.email', auto-complete='off',
            size='large', @change='modifyUserEmail')
        el-form-item(label='Όνομα Χρήστη', prop='username', size='large', v-show='!modifyRole && !addForeignUser')
          el-input.register(type='username', v-model='userCredentials.username',
            auto-complete='off', size='large')
        el-form-item(label='Επώνυμο', prop='surname', size='large', v-show='!modifyRole')
          el-input.register(type='name', v-model='userCredentials.surname', auto-complete='off', size='large',
            @change='modifyUserName', @input="userCredentials.surname = userCredentials.surname.toUpperCase()")
        el-form-item(label='Όνομα', prop='name', size='large', v-show='!modifyRole')
          el-input.register(type='name', v-model='userCredentials.name', auto-complete='off', size='large',
            @change='modifyUserName', @input="userCredentials.name = userCredentials.name.toUpperCase()")
        el-form-item(label='Πατρώνυμο', prop='fatherName', size='large', v-show='!modifyRole')
          el-input.register(type='name', v-model='userCredentials.fatherName', auto-complete='off', size='large',
            @change='modifyUserEmail', @input="userCredentials.fatherName = userCredentials.fatherName.toUpperCase()")
        el-form-item(label='Μητρώνυμο', prop='motherName', size='large', v-show='!modifyRole')
          el-input.register(type='name', v-model='userCredentials.motherName', auto-complete='off', size='large',
            @change='modifyUserName', @input="userCredentials.motherName = userCredentials.motherName.toUpperCase()")
        el-form-item(label='Σταθερό Τηλ.', prop='landline', size='large', v-show='!modifyRole && !addForeignUser')
          el-input.register(type='name', v-model='userCredentials.landline', auto-complete='off',
            size='large', @change='modifyUserName')
        el-form-item(label='Κινητό', prop='mobile', size='large', v-show='!modifyRole')
          el-input.register(type='name', v-model='userCredentials.mobile', auto-complete='off',
            size='large', @change='modifyUserName')
        hr(v-show='!modifyRole')
        el-form-item(label='Περιοχή', prop='addressArea', size='large', v-show='!modifyRole && !addForeignUser')
          el-input.register(type='name', v-model='userCredentials.addressArea', auto-complete='off', size='large',
            @change='modifyUserEmail'  @input="userCredentials.addressArea = userCredentials.addressArea.toUpperCase()")
        el-form-item(label='Πόλη', prop='addressCity', size='large', v-show='!modifyRole && !addForeignUser')
          el-input.register(type='name', v-model='userCredentials.addressCity', auto-complete='off',
            size='large', @change='modifyUserName'  @input="userCredentials.addressCity = userCredentials.addressCity.toUpperCase()")
        el-form-item(label='Χώρα', prop='addressCountry', size='large', v-show='!modifyRole && !addForeignUser')
          el-input.register(type='name', v-model='userCredentials.addressCountry', auto-complete='off',
            size='large', @change='modifyUserName'  @input="userCredentials.addressCountry = userCredentials.addressCountry.toUpperCase()")
        el-form-item(label='Διεύθυνση', prop='addressStreet', size='large', v-show='!modifyRole && !addForeignUser')
          el-input.register(type='name', v-model='userCredentials.addressStreet', auto-complete='off',
            size='large', @change='modifyUserEmail'  @input="userCredentials.addressStreet = userCredentials.addressStreet.toUpperCase()")
        el-form-item(label='Τ.Κ.', prop='addressZipCode', size='large', v-show='!modifyRole && !addForeignUser')
          el-input.register(type='name', v-model='userCredentials.addressZipCode', auto-complete='off',
            size='large', @change='modifyUserName')
        hr(v-show='modifyUser && !modifyRole')
        el-form-item(label='Ταυτότητα', prop='adtNo', size='large', v-show='!modifyRole && !addForeignUser')
          el-input.register(type='name', v-model='userCredentials.adtNo', auto-complete='off',
            size='large', @change='modifyUserEmail')
        el-form-item(label='ΑΦΜ', prop='afm', size='large', v-show='!modifyRole && !addForeignUser')
          el-input.register(type='name', v-model='userCredentials.afm', auto-complete='off',
            size='large', @change='modifyUserName', :disabled='modifyFromUser')
        el-form-item(label='Η/νια Γέννησης', prop='dateOfBirth', size='large', v-show='!modifyRole')
          el-date-picker(v-model="userCredentials.dateOfBirth", type="date", placeholder="Επιλέξτε Ημερομην.",
            format="dd-MM-yyyy", value-format="dd-MM-yyyy")
        el-form-item(label='ΔΟΥ', prop='doy', size='large', v-show='!modifyRole && !addForeignUser')
          el-input.register(type='name', v-model='userCredentials.doy', auto-complete='off',
            size='large', @change='modifyUserName')
        el-form-item(label='Αριθμός Διαβατηρίου', prop='foreignerId.number', size='large', v-if='!modifyRole && addForeignUser')
          el-input.register(type='name', v-model='userCredentials.foreignerId.number', auto-complete='off',
            size='large', @change='modifyUserName')
        el-form-item(label='Χώρα έκδοσης', prop='foreignerId.country', size='large', v-if='!modifyRole && addForeignUser')
          el-input.register(type='name', v-model='userCredentials.foreignerId.country', auto-complete='off',
            size='large', @change='modifyUserName'  @input="userCredentials.foreignerId.country = userCredentials.foreignerId.country.toUpperCase()")
        el-form-item(label='ΙΒΑΝ', prop='iban', size='large', v-show='!modifyRole && !addForeignUser')
          el-input.iban(type='name', v-model='userCredentials.iban', auto-complete='off',
            size='large', @change='modifyUserEmail')
            br
        hr(v-if="this.activeRole === 'Admin'")
        br(v-if="this.activeRole === 'Admin'")
        el-form-item(label='ID χρήστη ΣΗΔΕ', prop='eProtocol_userId', size='large', v-if="this.activeRole === 'Admin'", v-show='!modifyRole && !addForeignUser')
          el-input.register(type='number', min='1', step='1', v-model='userCredentials.eProtocol_userId', auto-complete='off',
            size='large', @change='modifyUserEmail')
            br
        el-form-item(label='Ειδικότητα', prop='specialty', size='large', v-show='showSpecialties')
          el-select(style='padding-right: 10px' v-model="selectedSpecialty" placeholder="Επιλέξτε" @change='changeSelectedSpecialty' :disabled="this.activeRole !== 'Admin'")
            el-option(v-for="specialty in academicAreas", :key="specialty.id", :label="specialty.name", :value="specialty.id")
          el-alert(:closable='true' v-if="showSpecialties && !this.selectedSpecialty && this.activeRole === 'Admin'",
          title='Πρέπει να επιλέξετε την ειδικότητα του συμβούλου' type='warning' show-icon='' style='display: inline')
        hr(v-show='!modifyRole')
        el-form-item(v-show='modifyRole && !modifyFromUser && !addForeignUser', label='Χρήστες/Ρόλο')
          el-transfer(style='text-align: left; display: inline-block',
            v-model='usersPerRole',
            @change='addUserToRole',
            filterable='',
            :titles="['Απομείναντες Χρήστες', 'Χρήστες Ρόλου']",
            :button-texts="['Αφαίρεση', 'Προσθήκη']",
            :data='users')
            span(slot-scope='{ option }') {{ option.label }}
        el-form-item(v-show='!modifyRole && !modifyFromUser && !addForeignUser', label='Επιλογή Ρόλων')
          el-transfer(style='text-align: left; display: inline-block',
            v-model='userRoles',
            @change='addRoleToUser',
            filterable='',
            :titles="['Απομείναντες Ρόλοι', 'Ρόλοι Χρήστη']",
            :button-texts="['Αφαίρεση', 'Προσθήκη']",
            :data='rolesHere')
            span(slot-scope='{ option }') {{ option.key }} - {{ option.label }}
        .saveButtons(style='text-align: center')
          el-button(type='primary', v-show='modifyRole', @click='roleSave',
            :disabled='!modifiedRole') Αποθήκευση Ρόλου
        div(v-show='modifyRole && roleId === 3 && !modifyFromUser && !addForeignUser')
          hr
          el-form-item(label='Επιλογή Επιτροπής')
            el-select(v-model="selectedBoard" placeholder="Select" @change='newSelectedBoard')
              el-option(v-for="item in boards", :key="item.id", :label="item.name", :value="item.name")
              //- el-option(:key="0", :label="", :value="0")
          div(v-if='selectedBoard !== ""')
            el-form-item(label='Επιλογή Μελών Επιτροπής')
              el-transfer(style='text-align: left; display: inline-block',
                v-model='specificBoardMembers',
                @change='addUserToRole',
                filterable='',
                :titles="['Χρήστες Συμβουλίων', 'Χρήστες Συμβουλίου']",
                :button-texts="['Αφαίρεση', 'Προσθήκη']",
                :data='executiveBoardMembers')
                span(slot-scope='{ option }') {{ option.label }}
        .saveButtons(style='text-align: center')
          el-popover(ref='popover', placement='top-start', title='Προυποθέσεις Αποθήκευσης',
            width='200', trigger='hover',
            content='Συμπληρώστε όλα τα πεδία και δώστε ρόλο/ους στον χρήστη')
          el-button(type='primary', v-show='!modifyRole && !addForeignUser', @click='userSave',
            v-popover:popover="") Αποθήκευση Χρήστη
          el-popover(ref='popover2', placement='top-start', title='Προυποθέσεις Αποθήκευσης',
            width='200', trigger='hover',
            content='Συμπληρώστε όλα τα υποχρεωτικά πεδία')
          el-button(type='primary', v-show='!modifyRole && addForeignUser', @click='foreignUserSave',
            v-popover:popover2="") Αποθήκευση Αλλοδαπού Χρήστη
          el-button(type='danger', v-show='!modifyRole && !addUser && !modifyFromUser && !addForeignUser', @click='userDelete',
            icon="el-icon-delete") Διαγραφή Χρήστη
          el-button(type='primary', v-if='modifyRole && roleId === 3 && !modifyFromUser && !addForeignUser', @click='boardSave',
            :disabled='!canSaveBoard') Αποθήκευση Συμβουλίου
          el-button(type='info', v-if='modifyFromUser && !addForeignUser', @click='backToApplications') Επιστροφή
          el-button(type='warning', v-if='!modifyFromUser && modifyUser && !modifyRole && !addUser && !addForeignUser', @click='newPassword') Νέος Κωδικός
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import router from '../../router/index'
import axios from 'axios'
import sharedMethods from '../common/sharedMethods.js'
import shortDictionary from '../../store/shortDictionary'

export default {
  components: {
    shortDictionary
  },
  mounted: function () {
    if (this.activeRole === 'Admin') {
      this.$store.dispatch('LOAD_BOARDS')
    }
    this.userCredentials = this.currentUser
  },
  props: {
    modifyFromUser: { type: Boolean, default: false },
    modifyUser: { type: Boolean, default: false },
    addUser: { type: Boolean, default: false },
    modifyRole: { type: Boolean, default: false },
    addForeignUser: {type: Boolean, default: false},
    userData: {},
    roleId: { type: Number },
    academicAreas: {type: Array}
  },
  mixins: [sharedMethods],
  // directives: {
  //   uppercase: {
  //     update (el) {
  //       if (el.value) { el.value = el.value.toUpperCase() }
  //     }
  //   }
  // },
  data () {
    return {
      selectedSpecialty: null,
      showSpecialties: false,
      checkBoards: false,
      changePassword: false,
      boardUsers: 0,
      userCredentials: {name: '', email: '', password: '', passwordConfirmation: ''},
      boards: this.allBoards,
      selectedBoard: '',
      canSave: true,
      usersPerRole: [],
      specificBoardMembers: [],
      savingChanges: false,
      userRoles: [],
      modifiedEmail: false,
      modifiedUsername: false,
      modifiedPassword: false,
      modifiedRoles: false,
      modifiedUser: true,
      modifiedRole: false
    }
  },
  computed: {
    validationRules () {
      let validatePass = (rule, value, callback) => {
        if (value !== undefined && this.modifyFromUser && this.changePassword) {
          if (value === '') {
            callback(new Error('Παρακαλώ εισάγετε μυστικό κωδικό'))
          } else if (!value.match(/^(?=.*[0-9])(?=.*[a-z])(?=.*[A-Z])([a-zA-Z0-9@*#!$%^&*()_+={}:";'<>?,./]{8,})$/)) {
            callback(new Error('Ο κωδικός θα πρέπει να περιέχει τουλάχιστον 8 χαρακτήρες εκ των οποίων τουλάχιστον ένα ψηφίο, ένα μικρό και ένα κεφαλαίο γράμμα'))
          } else if (this.userCredentials.passwordConfirmation !== '') {
            this.$refs.userCredentials.validateField('passwordConfirmation')
          }
          callback()
        } else {
          callback()
        }
      }
      let validatePass2 = (rule, value, callback) => {
        if (value !== undefined && this.modifyFromUser && this.changePassword) {
          if (value === '') {
            callback(new Error('Παρακαλώ εισάγετε ξανά τον κωδικό σας'))
          } else if (value !== this.userCredentials.password) {
            callback(new Error('Ασυμφωνία κωδικών'))
          } else {
            callback()
          }
        } else {
          callback()
        }
      }
      if (this.addForeignUser) {
        return {
          email: [{ required: true, message: 'Παρακαλώ εισάγετε μια διευθυνση email', trigger: 'change' },
            { type: 'email', message: 'Παρακαλώ εισάγετε μια έγκυρη διευθυνση email', trigger: 'change' }],
          name: [{ required: true, message: 'Παρακαλώ εισάγετε το Όνομα', trigger: 'change' }],
          surname: [{ required: true, message: 'Παρακαλώ εισάγετε το Επώνυμο', trigger: 'change' }],
          motherName: [{ required: true, message: 'Παρακαλώ εισάγετε το Μητρώνυμο', trigger: 'change' }],
          fatherName: [{ required: true || this.addForeignUser, message: 'Παρακαλώ εισάγετε το Πατρώνυμο', trigger: 'change' }],
          dateOfBirth: [{ required: true, message: 'Παρακαλώ εισάγετε την ημερομηνία γέννησης', trigger: 'change' }],
          'foreignerId.number': [{ required: true, message: 'Παρακαλώ εισάγετε αριθμό Διαβατηρίου', trigger: 'change' }],
          'foreignerId.country': [{ required: true, message: 'Παρακαλώ εισάγετε τη χώρα έκδοσης', trigger: 'change' }]
        }
      } else {
        return {
          oldPassword: [{ required: this.modifyFromUser && this.changePassword, message: 'Παρακαλώ εισάγετε τον τρέχοντα κωδικό', trigger: 'change' }],
          password: [{ required: this.modifyFromUser && this.changePassword, message: 'Παρακαλώ εισάγετε νέο κωδικό', trigger: 'change' },
            { validator: validatePass, trigger: 'change' }],
          email: [{ required: true, message: 'Παρακαλώ εισάγετε μια διευθυνση email', trigger: 'change' },
            { type: 'email', message: 'Παρακαλώ εισάγετε μια έγκυρη διευθυνση email', trigger: 'change' }],
          passwordConfirmation: [{ required: this.modifyFromUser && this.changePassword, message: 'Παρακαλώ εισάγετε ξανά το νέο κωδικό', trigger: 'change' },
            { validator: validatePass2, trigger: 'change' }],
          mobile: [{ required: this.modifyFromUser, matches: '[0-9]+', min: 10, max: 20, message: 'Ο αριθμός του κινητού πρέπει να αποτελείται από 10 μέχρι 20 ψηφία χωρίς κενά', trigger: 'change' }],
          landline: [{ required: this.modifyFromUser, matches: '[0-9]+', min: 10, max: 20, message: 'Ο αριθμός του τηλεφώνου πρέπει να αποτελείται από 10 μέχρι 20 ψηφία χωρίς κενά', trigger: 'change' }],
          iban: [{ required: false, message: 'Παρακαλώ εισάγετε το IBAN', trigger: 'change' },
            { min: 27, max: 27, message: 'το IBAN πρέπει να είναι 27 ψηφία', trigger: 'change' }],
          username: [{ required: true, message: 'Παρακαλώ εισάγετε το Όνομα Χρήστη', trigger: 'change' }],
          name: [{ required: true, message: 'Παρακαλώ εισάγετε το Όνομα', trigger: 'change' }],
          surname: [{ required: true, message: 'Παρακαλώ εισάγετε το Επώνυμο', trigger: 'change' }],
          motherName: [{ required: this.modifyFromUser, message: 'Παρακαλώ εισάγετε το Μητρώνυμο', trigger: 'change' }],
          fatherName: [{ required: this.modifyFromUser || this.addForeignUser, message: 'Παρακαλώ εισάγετε το Πατρώνυμο', trigger: 'change' }],
          addressCountry: [{ required: this.modifyFromUser, message: 'Παρακαλώ εισάγετε την Χώρα', trigger: 'change' }],
          addressArea: [{ required: this.modifyFromUser, message: 'Παρακαλώ εισάγετε την περιοχή', trigger: 'change' }],
          addressCity: [{ required: this.modifyFromUser, message: 'Παρακαλώ εισάγετε την Πόλη', trigger: 'change' }],
          addressStreet: [{ required: this.modifyFromUser, message: 'Παρακαλώ εισάγετε την οδό', trigger: 'change' }],
          addressZipCode: [{ required: this.modifyFromUser, message: 'Παρακαλώ εισάγετε τον Ταχυδρομικό Κωδικό', trigger: 'change' }],
          adtNo: [{ required: this.modifyFromUser, message: 'Παρακαλώ εισάγετε τον αριθμό του δελτίου ταυτότητας', trigger: 'change' }],
          afm: [{ required: this.modifyFromUser || this.addUser, message: 'Παρακαλώ εισάγετε τον Αριθμό Φορολογικού Μητρώου', trigger: 'change' },
            { min: 9, max: 9, message: 'το ΑΦΜ πρέπει να είναι 9 ψηφία', trigger: 'change' }],
          doy: [{ required: this.modifyFromUser, message: 'Παρακαλώ εισάγετε την ΔΟΥ που ανήκετε', trigger: 'change' },
            {max: 40, message: 'Η ΔΟΥ πρέπει να είναι λιγότερο από 100 γράμματα', trigger: 'change'}],
          dateOfBirth: [{ required: this.addForeignUser, message: 'Παρακαλώ εισάγετε την ημερομηνία γέννησης', trigger: 'change' }]
        }
      }
    },
    canSaveBoard () {
      return this.boardUsers === 3 || this.boardUsers === 0
    },
    executiveBoardMembers () {
      // filter users that have the executiveBoardMember role
      return this.roles.find(role => role.name === 'ExecutiveBoardMember')
        ? this.roles.find(role => role.name === 'ExecutiveBoardMember')
          .users.map(role => { return {key: role.id, label: role.name + ' ' + role.surname} })
        : ''
    },
    rolesHere () {
      return this.roles.map(role => { return {key: role.id, label: role.gr_name} })
    },
    roleName () {
      return (this.roles.length !== 0 && this.roleId !== 0)
        ? this.roles.find(role => role.id === this.roleId).name : 'noNameRole'
    },
    specialties () {
      return this.specialties.map(specialty => {
        return {
          key: specialty.id,
          label: specialty.name
        }
      })
    },
    users () {
      return this.internalUsers.map(user => {
        if (this.roleId === 4 && user.specialty.name) {
          return {
            key: user.id,
            label: `${user.surname},  ${user.name.substring(0, 1)}. ,${user.specialty.name}`
          }
        } else {
          return {
            key: user.id,
            label: `${user.surname},  ${user.name.substring(0, 1)}.`
          }
        }
      })
    },
    ...mapGetters(['activeRole', 'roles', 'internalUsers', 'allBoards', 'currentUser', 'loadingInternalUsers', 'loadingSpecialties']),
    ...mapState(['BASE_URL'])
  },
  methods: {
    // clearPasswordFields () {
    //   this.userCredentials.oldPassword = ''
    //   this.userCredentials.password = ''
    //   this.userCredentials.passwordConfirmation = ''
    // },
    translate (term) {
      return shortDictionary[term]
    },
    changeSelectedSpecialty () {
      console.log('this.selectedSpecialty', this.selectedSpecialty)
    },
    hideForm () {
      this.clearForm()
      this.$emit('hideForm')
    },
    newPassword () {
      this.savingChanges = true
      let dataPut = this.userCredentials
      dataPut['roles'] = this.userRoles
      axios.put(`${this.BASE_URL}/users/${this.userData.id}?reset=password`, dataPut)
        .then((response) => {
          this.savingChanges = false
          this.modifySuccess(this.userCredentials.name, this.userCredentials.surname, 'Μετατροπή Δεδομένων')
          this.$store.dispatch('LOAD_INTERNAL_USERS')
          this.$store.dispatch('LOAD_INTERNAL_ROLES')
          this.$emit('hideForm')
        }).catch(err => {
          this.backendError(err)
          this.savingChanges = false
          this.modifyError(this.userCredentials.name, this.userCredentials.surname, 'Μετατροπή Δεδομένων')
        })
    },
    backToApplications () {
      router.replace(`/${this.activeRole}`)
    },
    newSelectedBoard (board) {
      this.checkBoards = true
    },
    modifySuccess (name, surname, operation) {
      this.$notify.success({
        title: `Επιτυχής ${operation}`,
        message: `Για τον χρήστη ${name} ${surname}`,
        offset: 100
      })
    },
    modifyError (name, surname, operation) {
      this.$notify.error({
        title: `Ανεπιτυχής ${operation}`,
        message: `Η ${operation} του χρήστη ${name} ${surname} δεν πραγματοποιήθηκε`,
        offset: 100
      })
    },
    saveError (name, surname, operation) {
      this.$notify.error({
        title: `Ανεπιτυχής ${operation}`,
        message: `Παρακαλώ συμπληρώστε τα απαιτούμενα πεδία. Η ${operation} του χρήστη ${name} ${surname} δεν πραγματοποιήθηκε.`,
        offset: 100
      })
    },
    roleError (name, surname, operation) {
      this.$notify.error({
        title: `Ανεπιτυχής ${operation}`,
        message: `Παρακαλώ δώστε τουλάχιστον ένα ρόλο στον χρήστη. Η ${operation} του χρήστη ${name} ${surname} δεν πραγματοποιήθηκε.`,
        offset: 250
      })
    },
    specialtyError (name, surname, operation) {
      this.$notify.error({
        title: `Ανεπιτυχής ${operation}`,
        message: `Παρακαλώ συμπληρώστε την ειδικοτητα του χρήστη. Η ${operation} του χρήστη ${name} ${surname} δεν πραγματοποιήθηκε.`,
        offset: 250
      })
    },
    boardError () {
      this.$notify.warning({
        title: 'Προσοχή',
        message: 'Κάθε Συμβούλιο πρέπει να περιέχει ακριβώς τρία μέλη',
        offset: 100
      })
    },
    boardSuccess () {
      this.$notify.success({
        title: 'Επιτυχία',
        message: 'Μπορείτε να αποθηκεύσετε το Συμβούλιο',
        offset: 100
      })
    },
    roleSave () {
      this.savingChanges = true
      axios.put(`${this.BASE_URL}/roles/${this.roleId}`,
        { users: this.usersPerRole })
        .then((response) => {
          this.savingChanges = false
          this.$notify.success({
            title: `Επιτυχής Αλλαγή Χρηστών Ρόλου`,
            message: `Ο ρόλος έχει πλέον ${this.usersPerRole.length} χρήστες`,
            offset: 100
          })
          this.$store.dispatch('LOAD_INTERNAL_USERS')
          this.$store.dispatch('LOAD_INTERNAL_ROLES')
          this.modifiedRole = false
        }).catch(err => {
          this.backendError(err)
          this.savingChanges = false
          this.$store.dispatch('LOAD_INTERNAL_USERS')
          this.$store.dispatch('LOAD_INTERNAL_ROLES')
          this.$notify.error({
            title: `Ανεπιτυχής Αλλαγή Χρηστών Ρόλου`,
            message: `Η αλλαγή δεν πραγματοποιήθηκε`,
            offset: 100
          })
        })
    },
    boardSave () {
      this.savingChanges = true
      axios.put(
        `${this.BASE_URL}/admins/uid/executive_boards/${this.boards.find(board => board.name === this.selectedBoard).id}`,
        { membersId: this.specificBoardMembers }
      ).then((response) => {
        this.savingChanges = false
        // this.modifySuccess(this.userCredentials.name, 'Μετατροπή Δεδομένων')
        this.$store.dispatch('LOAD_INTERNAL_USERS')
        this.$store.dispatch('LOAD_INTERNAL_ROLES')
        this.$store.dispatch('LOAD_BOARDS')
        this.modifiedRole = false
        this.$notify.success({
          title: 'Επιτυχία',
          message: 'Το Συμβούλιο αποθηκεύτηκε επιτυχώς',
          offset: 100
        })
      }).catch(err => {
        this.backendError(err)
        this.savingChanges = false
        this.modifyError(this.userCredentials.name, this.userCredentials.surname, 'Μετατροπή Δεδομένων')
      })
    },
    userDelete () {
      this.savingChanges = true
      axios.delete(`${this.BASE_URL}/users/${this.userData.id}`)
        .then((response) => {
          this.savingChanges = false
          this.clearForm()
          this.modifySuccess(this.userData.name, this.userData.surname, 'Διαγραφή')
          this.$store.dispatch('LOAD_INTERNAL_USERS')
          this.$emit('hideForm')
        }
        ).catch(err => {
          this.backendError(err)
          this.savingChanges = false
          this.modifyError(this.userData.name, this.userData.surname, 'Διαγραφή')
        })
    },
    foreignUserSave () {
      this.$refs['userCredentials'].validate((valid) => {
        if (valid) {
          this.savingChanges = true
          // let userCredentials = {}
          let dataPost = { userCredentials: this.userCredentials }
          axios.post(`${this.BASE_URL}/foreignusers`, dataPost)
            .then((response) => {
              this.savingChanges = false
              this.modifySuccess(this.userCredentials.name, this.userCredentials.surname, 'Αποθήκευση')
              this.$store.dispatch('LOAD_INTERNAL_USERS')
              this.$store.dispatch('LOAD_INTERNAL_ROLES')
              this.clearForm()
              this.$emit('hideForm')
            }).catch(err => {
              this.savingChanges = false
              this.modifyError(this.userCredentials.name, this.userCredentials.surname, 'Αποθήκευση')
              this.backendError(err)
            })
        } else {
          this.saveError('Αλλοδαπός', ' χρήστης', 'Αποθήκευση')
        }
      })
    },
    userSave () {
      let rolesOk = false
      this.$refs['userCredentials'].validate((valid) => {
        if (this.userRoles.length === 0 && !this.modifyFromUser && (this.addUser || this.modifyUser)) {
          this.roleError(this.userCredentials.name, this.userCredentials.surname, 'Αποθήκευση')
        } else if (this.userRoles.includes(4) && !this.selectedSpecialty) {
          this.specialtyError(this.userCredentials.name, this.userCredentials.surname, 'Αποθήκευση')
        } else {
          rolesOk = true
        }
        if (valid && rolesOk) {
          this.savingChanges = true
          if (!this.addUser) {
            let dataPut = {}
            if (!this.changePassword) {
              delete this.userCredentials.oldPassword
              delete this.userCredentials.password
              delete this.userCredentials.passwordConfirmation
            }
            if (this.modifyUser && !this.modifyFromUser) {
              console.log('this.modifyUser && !this.modifyFromUser')
              this.userCredentials.roles = this.userRoles
              this.userCredentials.specialty.id = this.selectedSpecialty
              this.userCredentials.modifyFromUser = this.modifyFromUser
              dataPut = this.userCredentials
              // dataPut['roles'] = this.userRoles
            } else if (this.modifyFromUser && this.modifiedUser) {
              console.log('this.modifyFromUser && this.modifiedUser')
              this.userCredentials.roles = []
              this.userCredentials.modifyFromUser = this.modifyFromUser
              dataPut = this.userCredentials
            }
            axios.put(`${this.BASE_URL}/users/${this.userData.id}`, dataPut)
              .then((response) => {
                this.savingChanges = false
                this.modifySuccess(this.userCredentials.name, this.userCredentials.surname, 'Μετατροπή Δεδομένων')
                if (this.activeRole === 'Admin') {
                  this.$store.dispatch('LOAD_INTERNAL_USERS')
                  // this.$store.dispatch('LOAD_INTERNAL_USERS')
                  this.$store.dispatch('LOAD_INTERNAL_ROLES')
                }
                this.$emit('hideForm')
                if (this.modifyFromUser && this.changePassword) {
                  this.$store.dispatch('logout')
                }
              }).catch(err => {
                this.backendError(err)
                this.savingChanges = false
                // this.showSpecialties = false
                this.modifyError(this.userCredentials.name, this.userCredentials.surname, 'Μετατροπή Δεδομένων')
              })
          } else if (this.modifiedUser && this.addUser) {
            this.savingChanges = true
            let dataPost = this.userCredentials
            dataPost['roles'] = this.userRoles
            dataPost['specialty'] = this.selectedSpecialty
            console.log('dataPost', dataPost)
            axios.post(`${this.BASE_URL}/users`, dataPost)
              .then((response) => {
                this.savingChanges = false
                this.selectedSpecialty = null
                this.showSpecialties = false
                this.modifySuccess(this.userCredentials.name, this.userCredentials.surname, 'Αποθήκευση')
                this.$store.dispatch('LOAD_INTERNAL_USERS')
                this.$store.dispatch('LOAD_INTERNAL_ROLES')
                this.clearForm()
                this.$emit('hideForm')
              }).catch(err => {
                this.backendError(err)
                this.savingChanges = false
                this.showSpecialties = false
                this.selectedSpecialty = null
                this.userRoles = []
                this.modifyError(this.userCredentials.name, this.userCredentials.surname, 'Αποθήκευση')
              })
          }
        } else {
          if (!valid) {
            this.saveError(this.userCredentials.name, this.userCredentials.surname, 'Αποθήκευση')
          }
          return false
        }
      })
    },
    modifyUserEmail (newEmail) {
      this.addUser === true
        ? this.modifiedEmail = !(newEmail === '')
        : this.modifiedEmail = !(newEmail === this.userData.email)
      this.checkCanSave()
    },
    modifyUserName (newName) {
      this.addUser === true
        ? this.modifiedUsername = !(newName === '')
        : this.modifiedUsername = !(newName === this.userData.name)
      this.checkCanSave()
    },
    modifyUserPassword (newPassword) {
      this.modifyFromUser === true && this.changePassword
        ? this.modifiedPassword = !(newPassword === '')
        : this.modifiedPassword = !(newPassword === this.userData.password)
      this.checkCanSave()
    },
    addRoleToUser (newRoles) {
      let oldRoles = this.addUser ? [] : this.userData.roles.map(role => role.id)
      this.modifiedRoles = !(newRoles.length === oldRoles.length &&
        newRoles.sort((a, b) => a - b).every((val, index) => val === oldRoles[index]))
      // th
      if (this.userRoles.includes(4)) {
        this.showSpecialties = true
        console.log('this.selectedSpecialty', this.selectedSpecialty)
      } else {
        this.selectedSpecialty = null
        this.showSpecialties = false
        console.log('this.selectedSpecialty', this.selectedSpecialty)
      }
      this.checkCanSave()
    },
    addUserToRole (newUsers) {
      this.boardUsers = newUsers.length
      let oldUsers = this.roles.find(role => role.id === this.roleId).users.map(user => user.id)
      this.modifiedRole = !(newUsers.length === oldUsers.length && newUsers.every((val, index) => val === oldUsers[index]))
    },
    checkCanSave: function () {
      this.canSave = true
      // this.modifiedUser = this.modifiedEmail || this.modifiedUsername || this.modifiedPassword || this.modifiedRoles
      // this.modifiedUser === true && this.userRoles.length > 0
      //   ? this.canSave = true : this.canSave = false
    },
    clearForm () {
      if (!this.addForeignUser) {
        this.userCredentials = {
          name: '',
          password: '',
          email: '',
          roles: [],
          afm: '',
          username: '',
          surname: '',
          fatherName: '',
          motherName: '',
          dateOfBirth: '',
          addressCountry: '',
          addressArea: '',
          addressCity: '',
          addressStreet: '',
          addressZipCode: '',
          landline: '',
          mobile: '',
          adtNo: '',
          doy: '',
          iban: '',
          eProtocol_userId: '',
          passwordConfirmation: ''
        }
      } else {
        this.userCredentials = {
          name: '',
          email: '',
          surname: '',
          fatherName: '',
          motherName: '',
          dateOfBirth: '',
          roles: [],
          foreignerId: { number: '', country: '' }
        }
      }
    },
    // must restore values to initial values when loaded
    resetForm () {
      this.clearForm()
    }
  },
  watch: {
    canSaveBoard: function () {
      if (this.checkBoards === true) {
        this.canSaveBoard === false
          ? this.boardError() : this.boardSuccess()
      }
    },
    allBoards: function (newData, oldData) {
      this.boards = newData
    },
    userData: function (newData, oldData) {
      if (newData.roles !== undefined) {
        this.userRoles = newData.roles.map(relation => relation.id)
        if (this.userRoles.includes(4)) {
          this.showSpecialties = true
          this.selectedSpecialty = newData.specialty.id
        } else {
          this.showSpecialties = false
          this.selectedSpecialty = null
        }
      } else {
        this.userRoles = []
      }
      this.canSave = true
      this.modifiedUser = true
      if (this.addForeignUser) {
        this.userCredentials = newData
        this.$set(this.userCredentials, 'foreignerId', {number: '', country: ''})
        // this.userCredentials.foreignerId = {number: '', country: ''}
      } else {
        // delete this.userCredentials.foreignerId
        this.userCredentials = newData
      }
    },
    roleId: function (newData, oldData) {
      this.showSpecialties = false
      this.modifiedRole = false
      this.usersPerRole = this.roles.length > 1 && this.roleId !== 0
        ? (this.roles.find(role => role.id === this.roleId).users).map(user => user.id) : []
    },
    roles: function (newData, oldData) {
      this.modifiedRole = false
      this.usersPerRole = this.roles.length > 1 && this.roleId !== 0
        ? (this.roles.find(role => role.id === this.roleId).users).map(user => user.id) : []
    },
    selectedBoard: function (newData, oldData) {
      this.boards = this.allBoards
      this.specificBoardMembers = this.selectedBoard !== ''
        ? this.boards.find(board => board.name === this.selectedBoard).members.map(member => member.memberId) : []
      this.boardUsers = this.specificBoardMembers.length
    },
    addUser: function (newData, oldData) {
      if (newData) {
        this.showSpecialties = false
        this.selectedSpecialty = null
      }
    }
  }
}
</script>

<style lang='scss'>
.saveButtons {
 align-self: center;
}
.el-card {
  margin-top: 5px;
}
div.el-transfer-panel {
  width: 350px
}
.register {
  > .el-input__inner {
    width: 220px
  }
}
.el-input {
    &.iban {
      width: 300px
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/common/RegisterForm.vue